import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function usePayments() {
  const [loading, setLoading] = useState(true);
  const [payments, setPayments] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.affiliates.payments.index)
      .then((response) => {
        setPayments(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, payments };
}
